import { generateId } from './generateId';

export const generateSig = (prefix = 'ESS') => {
	return generateId(prefix, 32);
};
